@use "@design/design-tokens/typography/typography" as *;
@use "@design/design-tokens/breakpoints/breakpoints" as *;

.root {
  display: flex;
  gap: 8px;
  align-items: center;
}

.flexColumn {
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  min-width: 0;
}

.titleLabel {
  @include typography-v2-body-sm;

  width: 100%;
  max-width: 212px;
  overflow: hidden;
  text-align: left;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-family: var(--font-nort);

  @include respond-to("max-lg") {
    padding-right: 20px;
  }
}

.tickerLabel {
  @include typography-v2-body-xs;

  overflow: hidden;
  text-align: left;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-family: var(--font-nort);
  color: var(--text-soft);
}
